import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Sections
import Hero from './sections/Hero';
import AboutClan from './sections/AboutClan';
import Streamers from './sections/Streamers';
import HowToJoin from './sections/HowToJoin';
import Footer from './sections/Footer';
import TopRanking from './sections/TopRanking';

const LandingPage = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-out',
      once: true,
      offset: 100
    });

    // Smooth scroll
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Revolution - Junte-se à Elite do Idhas</title>
        <meta 
          name="description" 
          content="Revolution. Junte-se aos melhores jogadores." 
        />
        <meta property="og:title" content="Revolution - Junte-se ao Clã" />
        <meta 
          property="og:description" 
          content="Faça parte do clã Revolution. Evolua seu personagem, participe de eventos épicos e domine o ranking." 
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/logo.png" />
      </Helmet>

      <div className="min-h-screen bg-white">
        <Hero />
        <AboutClan />
        <TopRanking />
        <HowToJoin />
        <Streamers />
        <Footer />
      </div>
    </>
  );
};

export default LandingPage;
